import React, { useRef, useEffect, useState } from "react";
import Chart from 'chart.js/auto';
import styled from "styled-components";
import axios from "axios";


const SixMonthSalesComparison = () => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(true);

    const todayDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    const fetchChartData = async () => {
        try {
            const response = await axios.get(
                `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/6MONTH_SALES_COMP/2024-01-01/${todayDate}/-/-/-/-/-`
            );
            setChartData(response.data[0]);
            console.log("6 month >>", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const chartRef = useRef(null);

    let chart = useRef()

    useEffect(() => {

        fetchChartData();

    }, []);

    useEffect(() => {

        if (chartData) {

            const barChartData = {
                labels: [""],
                datasets: [
                    {
                        label: "previous 6 month",
                        backgroundColor: "grey",
                        data: [chartData?.Previous6MonthsSales].map((k) => -k)
                    },
                    {
                        label: "current 6 month",
                        backgroundColor: "blue",
                        data: [chartData?.Current6MonthsSales]
                    }
                ]
            };

            const ctx = chartRef.current.getContext("2d");

            if (ctx) {
                if (chart.current) chart.current.destroy();
                chart.current = new Chart(ctx, {
                    type: "bar",
                    data: barChartData,
                    options: {
                        indexAxis: 'y',
                        responsive: true,
                        tooltips: {
                            intersect: false,
                            callbacks: {
                                label: (c) => {
                                    const value = Number(c.value);
                                    const positiveOnly = value < 0 ? -value : value;
                                    let retStr = "";
                                    if (c.datasetIndex === 0) {
                                        retStr += `참새방앗간: ${positiveOnly.toString()}%`;
                                    } else {
                                        retStr += `당근마켓: ${positiveOnly.toString()}%`;
                                    }
                                    return retStr;
                                }
                            }
                        },
                        legend: {
                            position: "bottom"
                        },
                        scales: {
                            x: {
                                stacked: true,
                            },
                            y: {
                                stacked: true
                            },
                            xAxes: [
                                {
                                    stacked: false,
                                    ticks: {
                                        beginAtZero: true,
                                        fontSize: 13,
                                        callback: (v) => {
                                            return v < 0 ? -v + "%" : v + "%";
                                        }
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true,
                                        fontSize: 13
                                    },
                                    position: "right"
                                }
                            ]
                        }
                    }
                });
            }
        }

    }, [chartData])

    return (
        <div>

            <div style={{ flexDirection: "row", display: "flex", justifyContent: "center" }}>
                <span className="flex" style={{ flexDirection: "column", alignItems: "center" }}>
                    <p style={{ fontSize: "20px",fontWeight:"bold", color: "#000000" }}>
                        {chartData?.Current6MonthsSales > chartData?.Previous6MonthsSales ? "+" :"-"}
                        {
                        chartData?.GrowthPercent.toFixed(2)

                    }%</p>
                    <p style={{color:"#7c7c7c"}}>Growth </p>
                </span>
            </div>

            <canvas style={{ height: "200px" }} ref={chartRef}>

            </canvas>
        </div>
    );
};

export default SixMonthSalesComparison;
